import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const productsOnboardingHubRoute: InvariantJiraRoute = {
	name: 'products-onboarding-hub',
	path: '/jira/settings/products/onboarding',
};
